import { Details, Paragraph, TextLinkCss, h5 } from "@/styles/typography";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Card = styled(Link)<{ $type: string }>`
  min-width: 300px;
  height: 100%;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.coreLight};

  &:hover {
    span {
      text-decoration-color: ${({ theme }) => theme.colors.textBody};
    }
  }

  @media screen and (min-width: 600px) {
    ${({ $type }) => $type === "small" && "max-width: 500px;"}
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 100%;
  }
`;

const CardVideo = styled.img`
  border-radius: 4px 4px 0 0;
  aspect-ratio: 16/9;
  object-fit: cover;
`;

const CardImage = styled(GatsbyImage)`
  border-radius: 4px 4px 0 0;
  aspect-ratio: 16/9;
  object-fit: cover;
`;

const CardInfo = styled.div`
  display: flex;
  padding: 16px 16px 0;
  gap: 16px;
  align-items: center;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 24px 24px 0;
  }
`;

const CardDetails = styled(Details)`
  color: ${({ theme }) => theme.colors.textBody};
  margin-top: 4px;
`;

const TextWrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 24px;
  }
`;

const CardTitle = styled(h5)``;

const CardIngress = styled(Paragraph)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

const CardLink = styled.span`
  ${TextLinkCss}
  color: ${({ theme }) => theme.colors.textBody};
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.3s;
`;

const S = {
  Card,
  CardImage,
  CardInfo,
  CardDetails,
  TextWrapper,
  CardTitle,
  CardIngress,
  CardLink,
  CardVideo,
};

export default S;
